import React from "react";
import { HeaderAction, HeaderComponent, ScreenSize } from "../../../types";

interface VisibilitySettingsProps {
	component: HeaderComponent;
	dispatch: React.Dispatch<HeaderAction>;
}

const VisibilitySettings: React.FC<VisibilitySettingsProps> = ({
	component,
	dispatch,
}) => {
	return (
		<div className="mb-4">
			<h4 className="text-md font-medium mb-2">Responsive Visibility</h4>

			<div className="mb-2">
				<label className="block text-sm font-medium mb-1">
					Hide in Sizes
				</label>
				<div className="flex flex-wrap gap-2">
					{["XS", "S", "M", "L", "XL"].map((size) => {
						const isHidden = component.hideInSizes?.includes(
							size as ScreenSize
						);

						return (
							<button
								key={size}
								className={`px-3 py-1 border rounded ${
									isHidden
										? "bg-blue-500 text-white"
										: "bg-white text-gray-700 hover:bg-gray-100"
								}`}
								onClick={() => {
									let newHideInSizes: ScreenSize[] = [];

									if (isHidden) {
										newHideInSizes = (
											component.hideInSizes || []
										).filter((s) => s !== size);
									} else {
										newHideInSizes = [
											...(component.hideInSizes || []),
											size as ScreenSize,
										];
									}

									dispatch({
										type: "UPDATE_COMPONENT",
										payload: {
											id: component.id,
											updates: {
												hideInSizes: newHideInSizes,
											},
										},
									});
								}}>
								{size}
							</button>
						);
					})}
				</div>
			</div>
		</div>
	);
};

export default VisibilitySettings;
